import { ValueFormHealth } from "../../../../../../constants/health";

const DefaultValueFormHealth = (
  isDisabled: boolean,
  defaultValue: string = ""
): ValueFormHealth => {
  return {
    value: defaultValue,
    errorCode: "",
    disabled: isDisabled,
    code: "",
  };
};

export interface ContactDataDto {
  mobilePhone: ValueFormHealth;
  landlinePhone: ValueFormHealth;
  emailInput: ValueFormHealth;
  sameAsTaker: boolean;
}

export const DefaultContactDataDto = (): ContactDataDto => {
  return {
    mobilePhone: DefaultValueFormHealth(false),
    landlinePhone: DefaultValueFormHealth(false),
    emailInput: DefaultValueFormHealth(false),
    sameAsTaker: false,
  };
};
